import { Legend } from "recharts";
import {
  PAGE_WIDTH_FOR_PRINT_PCI,
  RECHARTS_PRINT_WIDTH,
} from "../../../../constants/constants";

export default function getPciCustomLegend(width: number, title: string) {
  return (
    <Legend
      key={title + ": legend"}
      width={width === PAGE_WIDTH_FOR_PRINT_PCI ? RECHARTS_PRINT_WIDTH : width}
      wrapperStyle={{
        top: 0,
        left: -55,
      }} /** this makes the legend not collide with the bars */
      align={"center"}
      verticalAlign="top"
      layout="horizontal"
    />
  );
}
